import { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";
import { NAV_ITEMS } from "./constants";

// project links sorted so team projects appear below personal ones
const projectNavLinks = projects =>
  [...projects]
    .sort((a, b) => (a.team ? 1 : 0) - (b.team ? 1 : 0))
    .map(project => ({
      key: project.id,
      title: project.name,
      path: `/project/${project.id}`,
      dotColor: project.team && project.team.color
    }));

// hook to get nav items based on nav placement (menu or sidebar) & user role
export const useNavItems = navLocation => {
  const { user } = useContext(AuthContext);
  const role = user.adminUser ? "admin" : user.role;

  return NAV_ITEMS.filter(
    item => item.locations.includes(navLocation) && item.roles.includes(role)
  ).map(item =>
    item.key === "projects"
      ? { ...item, nestedLinks: projectNavLinks(user.projects || []) }
      : item
  );
};
